/* eslint-disable */

import * as themeConstants from '../../Constants/Theme/Theme.constants';

/**
 * Create styles for `<DeliveryDocket />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<DeliveryDocket />` styles
 */
const deliveryDocketStyles = ({ theme }) => {
  const icon = {
    height: theme.spacing(1) * 3,
    marginLeft: -theme.spacing(1) / 4,
    marginRight: theme.spacing(1) * 1.5,
    opacity: 0.7,
    width: theme.spacing(1) * 3,
  };
  return {
    activity: {
      borderBottom: `1px solid ${theme.palette.grey[`300`]}`,
      padding: `0 ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`,
    },
    activityDateType: {
      color: theme.palette.grey[700],
    },
    activityIcon: {
      opacity: `25%`,
    },
    column: {
      borderBottom: `1px solid ${theme.palette.grey[`300`]}`,
      marginBottom: theme.spacing(1),
      padding: `0 ${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`,
    },
    fixedWidthColumn: {
      maxWidth: theme.spacing(1) * 10,
      minWidth: theme.spacing(1) * 10,
    },
    group: {
      border: `1px solid ${theme.palette.grey[`300`]}`,
      padding: `0 ${theme.spacing(1) * 2}px 0 ${theme.spacing(1) * 2}px`,
    },
    heading: {
      margin: `${theme.spacing(1) * 2}px 0 ${theme.spacing(1) / 2}px 0`,
    },
    icon,
    lightText: {
      fontWeight: 100,
      opacity: 0.85,
      paddingLeft: theme.spacing(1) / 1.5,
    },
    rowText: {
      lineHeight: `1.4rem`,
    },
    warningIcon: {
      ...icon,
      marginLeft: theme.spacing(1),
    },
    accepted: {
      color: themeConstants.BORAL_GREEN,
    },
    paperClasses: {
      maxHeight: `40%`,
    },
    paperAddNote: {
      maxHeight: `60%`,
    },
    spinner: {
      marginBottom: 0,
      marginTop: 0,
    },
    docketStatus: {
      left: -theme.spacing(1) * 1.5,
      position: `relative`,
      top: theme.spacing(1),
    },
    docketComplete: {
      backgroundColor: themeConstants.BORAL_GREEN,
    },
    docketInProgress: {
      backgroundColor: themeConstants.BORAL_GREY,
    },
    highlighted: {
      opacity: 1,
      color: themeConstants.BORAL_GREEN,
    },
    kebabButton: {
      position: `absolute`,
      right: 0,
    },
    disclaimer: {
      paddingTop: theme.spacing(1),
    },
    iconHolder: {
      minWidth: 80,
    }
  };
};

export default deliveryDocketStyles;
